import type { IFieldState } from '@fff-web/fff-payments';
import Input from '../../../components/Input';
import TextArea from './TextArea';
import * as style from './recipient.module.scss';

type RecipientProps = {
  deliveryByEmail: boolean;
  name: IFieldState;
  email: IFieldState;
  message: IFieldState;
  lastName: IFieldState;
};

const Recipient = ({ deliveryByEmail, name, email, message, lastName }: RecipientProps) => (
  <div className={style.container}>
    <div className={style.names}>
      <Input
        type="text"
        id="recipientName"
        label="Friend's First Name"
        placeholder="Friend's First Name"
        inputStatus={name}
      />
      <Input
        type="text"
        id="recipientLastName"
        label="Friend's Last Name"
        placeholder="Friend's Last Name"
        inputStatus={lastName}
      />
    </div>
    {deliveryByEmail && (
      <Input
        type="email"
        id="recipientEmail"
        label="Friend's Email Address"
        placeholder="Friend's Email"
        inputStatus={email}
      />
    )}
    <TextArea
      id="message"
      placeholder="I think you're really going to love FabFitFun..."
      label="Your Personal Message (Optional)"
      textStatus={message}
      maxLength={255}
    />
    <div className={style.recipientsInformation}>
      Gift card recipients must be or become a FabFitFun member and provide a credit card in order
      to redeem a gift card.
    </div>
  </div>
);

export default Recipient;
